<template>
  <div class="container-custom">
    <!-- Breadcrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">EDM Subscribers</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>EDM Subscribers</h2>
      <v-spacer></v-spacer>
      <ExportFilter></ExportFilter>
    </div>
    <!-- block -->
    <div class="block mb-10">
      <EDMtable></EDMtable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import EDMtable from '@/views/F-2__EDMsubscriber/c/EDMtable.vue';
import ExportFilter from '@/views/F-2__EDMsubscriber/c/F-2-1__EDMsubscribersExport_Filter.vue';

export default {
  components: {
    ExportFilter,
    EDMtable,
  },
  async created() {
    this.clear();
    await this.getMembers();
    await this.getMemberCountries();
  },
  methods: {
    ...mapActions('member', {
      getMembers: 'find',
      getMemberCountries: 'getMemberCountries',
      clear: 'clear',
    }),
  },
};
</script>

<style></style>
